<template>
  <v-dialog :fullscreen="isMobile" width="620" v-model="dialog" scrollable>
    <v-card>
      <v-card-title class="primary white--text">
        <v-toolbar-title class="text-uppercase">Sửa hồ sơ giáo viên</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn dark icon>
          <v-icon @click="cancel">close</v-icon>
        </v-btn>
      </v-card-title>
      <v-divider />

      <v-card-text>
        <v-form ref="form">
          <div v-if="role.type !== 'teacher'">
            <h3 class="mb-2 mt-4">1. Thông tin cơ bản</h3>
            <teacher-general-form
              :teacher="teacher"
              ref="teacherGeneralForm"
              :formState="dialog"
              @onNameChanged="onNameChanged"
            ></teacher-general-form>
            <h3 class="mb-2 mt-4">2. Thông tin tại trường</h3>
            <teacher-school-form ref="teacherSchoolForm" :teacher="teacher" :formState="dialog"></teacher-school-form>
            <h3 class="mb-2 mt-4">3. Thông tin liên lạc</h3>
            <teacher-contact-form
              ref="teacherContactForm"
              :teacher="teacher"
              :formState="dialog"
            ></teacher-contact-form>
            <h3 class="mb-2 mt-4">4. Thông tin chuyên môn</h3>
            <TeacherSpecializeForm ref="teacherSpecializeForm" :teacher="teacher" :formState="dialog" />
            <!-- <h3 class="mb-2 mt-6">5. Thiết lập tổ trưởng, nhóm trưởng</h3> -->
            <!-- <TeacherLeaderConfigForm ref="teacherLeaderConfigForm" :teacher="teacher" :formState="dialog" /> -->
            <h3 class="mb-2 mt-12">5. Thông tin ghi chú về giáo viên</h3>
            <TeacherNoteForm ref="teacherNoteForm" :teacher="teacher" :formState="dialog"></TeacherNoteForm>
            <!-- <h3 class="mb-2">6. Thông tin tài khoản ngân hàng</h3> -->
            <!-- <TeacherBankAccountInfo ref="teacherBankAccountForm" :teacher="teacher" /> -->
            <h3 class="mb-2 mt-6">6. Thông tin tài khoản</h3>
            <TeacherAccountInfo
              ref="teacherAccountInfo"
              :teacher="teacher"
              :formState="dialog"
              :teacherUsername="teacherUsername"
            />
          </div>
          <div v-else>
            <h3 class="mb-2">1. Thông tin cơ bản</h3>
            <teacher-general-form
              :teacher="teacher"
              ref="teacherGeneralForm"
              :formState="dialog"
              @onNameChanged="onNameChanged"
            ></teacher-general-form>
            <h3 class="mb-2">2. Thông tin tại trường</h3>
            <teacher-school-form ref="teacherSchoolForm" :teacher="teacher" :formState="dialog"></teacher-school-form>
            <h3 class="mb-2">3. Thông tin liên lạc</h3>
            <teacher-contact-form
              ref="teacherContactForm"
              :teacher="teacher"
              :formState="dialog"
            ></teacher-contact-form>
            <h3 class="mb-2">4. Thông tin chuyên môn</h3>
            <TeacherSpecializeForm ref="teacherSpecializeForm" :teacher="teacher" :formState="dialog" />
            <h3 class="mb-2 mt-6">5. Thiết lập tổ trưởng, nhóm trưởng</h3>
            <TeacherLeaderConfigForm ref="teacherLeaderConfigForm" :teacher="teacher" :formState="dialog" />
            <h3 class="mb-2">6. Thông tin ghi chú về giáo viên</h3>
            <TeacherNoteForm ref="teacherNoteForm" :teacher="teacher" :formState="dialog"></TeacherNoteForm>
          </div>
        </v-form>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions class="d-flex justify-space-between pa-6">
        <v-btn class="text-none text-uppercase" outlined @click="cancel">Huỷ</v-btn>
        <v-btn color="primary text-none text-uppercase" elevation="0" @click="save">Lưu</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex'
import TeacherGeneralForm from '@/components/basic/form/TeacherGeneralForm'
import TeacherContactForm from '@/components/basic/form/TeacherContactForm'
import TeacherSchoolForm from '@/components/basic/form/TeacherSchoolForm'
import TeacherSpecializeForm from '@/components/basic/form/TeacherSpecializeForm'
import TeacherNoteForm from '@/components/basic/form/TeacherNoteForm.vue'
import TeacherAccountInfo from '@/components/basic/form/TeacherAccountInfo.vue'
// import TeacherBankAccountInfo from '@/components/basic/form/TeacherBankAccountInfo.vue'
import TeacherLeaderConfigForm from '@/components/basic/form/TeacherLeaderConfigForm.vue'
import get from 'lodash-es/get'
import { User } from '../../plugins/api'

export default {
  components: {
    TeacherGeneralForm,
    TeacherContactForm,
    TeacherSchoolForm,
    TeacherSpecializeForm,
    TeacherNoteForm,
    TeacherAccountInfo,
    // TeacherBankAccountInfo,
    TeacherLeaderConfigForm,
  },
  data() {
    return {
      dialog: false,
      name: '',
      phone: '',
      email: '',
      lastemail: '',
      username: '',
      username_indexing: '',
      username_no: 0,
      majors: '',
      show: false,
      password: '',
      emailError: '',
      isMobile: false,
    }
  },

  props: {
    state: Boolean,
  },
  computed: {
    ...mapState('teacher', ['teacher', 'teacherUsername']),
    ...mapGetters('auth', ['role']),
  },
  methods: {
    ...mapActions('user', ['changePassword', 'resetTeacherPassByAdmin']),
    ...mapActions('teacher', ['updateTeacher', 'setTeacherUsername']),
    async save() {
      let valid = false
      if (this.role.type === 'teacher') {
        valid = this.$refs.teacherAccountInfo.validate()
      } else {
        valid =
          this.$refs.teacherGeneralForm.validate() &&
          this.$refs.teacherSchoolForm.validate() &&
          this.$refs.teacherContactForm.validate() &&
          this.$refs.teacherSpecializeForm.validate() &&
          this.$refs.teacherSpecializeForm.validate() &&
          this.$refs.teacherAccountInfo.validate()
      }
      if (!valid) {
        return
      }
      try {
        this.$loading.active = true
        let teacherGeneralForm = {}
        let teacherSchoolForm = {}
        let teacherContactForm = {}
        let teacherSpecializeForm = {}
        let teacherNoteForm = {}
        let teacherBankAccountForm = {}
        let teacherLeaderConfigForm = {}
        if (this.role.type !== 'teacher') {
          teacherGeneralForm = await this.$refs.teacherGeneralForm.getData()
          teacherSchoolForm = this.$refs.teacherSchoolForm.getData()
          teacherContactForm = this.$refs.teacherContactForm.getData()
          teacherSpecializeForm = this.$refs.teacherSpecializeForm.getData()
          teacherNoteForm = this.$refs.teacherNoteForm.getData()
        }

        // change teacher name
        if (teacherGeneralForm.username) {
          // update account
          await User.update(this.teacher.user, {
            username: teacherGeneralForm.username,
            username_indexing: teacherGeneralForm.username_indexing,
            username_no: teacherGeneralForm.username_no,
          })
        }
        if (this.role.type === 'teacher') {
          const teacherAccountInfo = this.$refs.teacherAccountInfo.getData()
          if (teacherAccountInfo.oldPassword && teacherAccountInfo.newPassword) {
            await this.changePassword(teacherAccountInfo)
          }
        } else {
          const teacherAccountInfo = this.$refs.teacherAccountInfo.getData()
          if (teacherAccountInfo.newPassword) {
            await this.resetTeacherPassByAdmin({ id: this.teacher.user, newPassword: teacherAccountInfo.newPassword })
          }
          const updateParams = {
            id: this.teacher.id,
            ...teacherGeneralForm,
            status: teacherSchoolForm.status,
            subjectGroup: get(teacherSpecializeForm, 'subjectGroup.id', ''),
            address: teacherContactForm.currentLive,
            notes: teacherNoteForm.notes,
            phone: teacherContactForm.phone,
            email: teacherContactForm.email,
            type: teacherSchoolForm.type,
            academicLevels: teacherSpecializeForm.academicLevels
              ? teacherSpecializeForm.academicLevels.map((a) => a.id)
              : [],
            data: {
              ...get(this.teacher, 'data', {}),
              teachBankAccount: teacherBankAccountForm,
              subjectGroupConfig: teacherLeaderConfigForm,
            },
            metadata: {
              ...teacherContactForm,
              ...teacherSchoolForm,
              ...teacherSpecializeForm,
              ...teacherGeneralForm,
              ...teacherNoteForm,
            },
          }
          await this.updateTeacher(updateParams)
        }

        this.$alert.updateSuccess()
        this.dialog = false
      } catch (e) {
        this.$alert.updateError(e)
      } finally {
        this.$loading.active = false
      }
    },
    onNameChanged(teacherUsername) {
      this.setTeacherUsername(teacherUsername)
    },
    cancel() {
      this.dialog = false
    },
  },
  watch: {
    state() {
      this.dialog = true
      this.setTeacherUsername('')
    },
  },
}
</script>

<style scoped>
.v-data-footer {
  flex-wrap: nowrap;
}

.v-data-footer__icons-before {
  order: -1;
}
</style>
